import { Messages } from '../../../../codegen/Localize';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetDescriptionAction } from '../../../../ts/ServerApi/types/actionNames';
import { setDescriptionAction } from '../../../actions/spaces/SetDescriptionAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const SetDescriptionAction: IEntityAction<IContentInfo<'database'> | IContentInfo<'table'>, ISetDescriptionAction> = {
  name: EntityActionNames.SetDescription,
  translateName: Messages.editDescription1,
  isVisible: (_, state) => selectCatalogingOnSiteEnabled(state),
  isClickable: (availableActions: ISetDescriptionAction) => !!(availableActions && availableActions.setDescription),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDescription was called without exactly one item');
    }

    return setDescriptionAction(items[0]);
  }
};


export const SetMetricDescriptionAction: IEntityAction<IContentInfo<'metric'>, ISetDescriptionAction> = {
  name: EntityActionNames.SetDescription,
  translateName: Messages.editDescription1,
  isVisible: () => true,
  isClickable: (availableActions: ISetDescriptionAction) => !!(availableActions && availableActions.setDescription),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDescription was called without exactly one item');
    }

    return setDescriptionAction(items[0]);
  }
};

export const SetPublishedConnectionDescriptionAction: IEntityAction<IContentInfo<'publishedConnection'>, ISetDescriptionAction> = {
  name: EntityActionNames.SetDescription,
  translateName: Messages.editDescription1,
  isVisible: () => FeatureFlags.publishedConnectionContentManagementEnabled,
  isClickable: (availableActions: ISetDescriptionAction) => !!(availableActions && availableActions.setDescription),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDescription was called without exactly one item');
    }

    return setDescriptionAction(items[0]);
  }
};

